import styled from 'styled-components'

const WrapTextArea = styled.div`
    /* width: 100%;
    height: 100%; */
`
export { WrapTextArea }